import React, { useState, useEffect, useRef } from "react";
import { Box, Snackbar, CircularProgress } from "@mui/material";
import Table from "../Table";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import EditIcon from "../../assets/images/editIcon.svg";
import DeleteIcon from "../../assets/images/DeleteIcon.svg";
import AddEditCustomer from "./AddEditCustomer";
import DeleteModal from "./DeleteModal";
import {
  CustomerManagementData,
  deleteCustomer,
} from "../../Actions/CustomerManagementAction";
import SubHeader from "../SubHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  getCustomerAccess,
  processCustomerRows,
  triggerToast,
  getCustomerColumns,
} from "../../utils/customerUtils.js";
import "./mustyle.scss";

const GridWithLoader = ({ loading, rows, columns, setHasData }) =>
  loading && rows.length === 0 ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <Box sx={{ height: 400, width: "100%" }}>
      <Table columns={columns} rows={rows} setHasData={setHasData} />
    </Box>
  );

const Customer = () => {
  const [open, setOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [hasData, setHasData] = useState(true);
  const [actionButton, setActionButton] = useState("");
  const [editData, setEditData] = useState(null);
  const [selectedEditId, setSelectedEditid] = useState();
  const [deviceIdToDelete, setDeviceIdToDelete] = useState(null);

  const token = JSON.parse(localStorage.getItem("token"));
  const { create, edit, delete: canDelete } = getCustomerAccess(token);

  const dispatch = useDispatch();
  const { dashboardData, loading, toastMessage, toastOpen } = useSelector(
    (state) => state.customerData
  );

  const handleEdit = (deviceData, selectedEditId) => {
    setSelectedEditid(selectedEditId);
    setEditData(deviceData.row);
    setActionButton("edit");
    setOpen(true);
  };

  const columns = getCustomerColumns(
    edit,
    canDelete,
    handleEdit,
    setOpenDeleteModal,
    setDeviceIdToDelete,
    EditIcon,
    DeleteIcon,
    AccessibleTooltip
  );

  const processedRows = processCustomerRows(dashboardData);

  useEffect(() => {
    dispatch(CustomerManagementData());
  }, [actionButton]);

  const handleDelete = async (id) => {
    dispatch(deleteCustomer(id));
    triggerToast(dispatch, "Deleted Successfully");
  };

  const handleToastClose = () => {
    triggerToast(dispatch, " ", false);
  };

  const createBtnRef = useRef(null);

  useEffect(() => {
    if (createBtnRef.current) {
      createBtnRef.current.focus();
    }
  }, []);

  return (
    <>
      <span
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {!hasData
          ? "No data available"
          : `${processedRows.length} item${
              processedRows.length > 1 ? "s" : ""
            } found`}
      </span>

      <main
        className="main_ele_wrapper userMangement_wrapper"
        role="main"
        aria-label="Customer Management Section"
      >
        <SubHeader
          heading="Customer Management"
          headerButton={
            create && (
              <div
                className="AddUser new-entry"
                data-testid="add-user-button-wrapper-Desktop"
              >
                <button
                  ref={createBtnRef}
                  id="create-new-user-btn"
                  name="Create-New-User"
                  className="addDevice"
                  onClick={() => {
                    setOpen(true);
                    setActionButton("add");
                  }}
                  aria-label="Create new customer"
                >
                  Create Customer
                </button>
              </div>
            )
          }
        />

        <div className="new-EntryForMobile ">
          {create && (
            <div
              className="AddUser new-entry"
              data-testid="add-user-button-wrapper"
            >
              <button
                id="create-new-user-btn"
                name="Create-New-User"
                className="containedButton"
                onClick={() => {
                  setOpen(true);
                  setActionButton("add");
                }}
                aria-label="Create new customer"
              >
                Create Customer
              </button>
            </div>
          )}
        </div>

        <div className="inner_Wrapper">
          <div className="floorMangementTable_wrapper manageUserTable_wrapper">
            <GridWithLoader
              loading={loading}
              rows={processedRows}
              columns={columns}
              setHasData={setHasData}
            />
          </div>
        </div>
      </main>

      <AddEditCustomer
        open={open}
        setOpen={setOpen}
        setActionButton={setActionButton}
        actionButton={actionButton}
        editData={editData}
        handleClose={() => {
          setTimeout(() => {
            if (document.getElementById(selectedEditId)) {
              document.getElementById(selectedEditId).focus();
            }
          }, 200);
        }}
      />

      <DeleteModal
        setOpenDeleteModal={setOpenDeleteModal}
        openDeleteModal={openDeleteModal}
        handleDelete={() => handleDelete(deviceIdToDelete)}
      />

      <Snackbar
        open={toastOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        message={toastMessage}
        onClose={handleToastClose}
        className="success"
      />
    </>
  );
};

export default Customer;
